import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Stethoscope, GraduationCap, Building2, Scale } from 'lucide-react';
export function ProfessionalComparison() {
  const comparisons = [{
    situation: 'Entra un paciente sordo a la guardia',
    without: 'Papel y lapicera, malentendidos, estrés',
    with: 'Preguntás dónde duele, el tipo de dolor, las alergias'
  }, {
    situation: 'Un alumno sordo no entiende la consigna',
    without: 'Improvisás o dependés del intérprete',
    with: 'Señás "analizar", "justificar", "30 minutos", "individual"'
  }, {
    situation: 'Un cliente sordo quiere abrir una cuenta',
    without: 'Le explicás con gestos y nada queda claro',
    with: 'Explicás cuotas, intereses, mora y CBU en señas básicas'
  }, {
    situation: 'Un detenido sordo pide sus derechos',
    without: 'No podés comunicarlos sin intérprete',
    with: 'Señás "derecho a intérprete", "abogado defensor", "denuncia"'
  }, {
    situation: 'Un empleado sordo firma un contrato',
    without: 'No entiende qué firma',
    with: 'Explicás sueldo bruto, neto, período de prueba y aguinaldo'
  }];
  const modules = [{
    icon: <Stethoscope className="w-6 h-6" data-id="element-251" />,
    title: 'Módulo Salud',
    color: 'text-rose-600',
    bgColor: 'bg-rose-100',
    items: 'Anatomía interna avanzada · Tipos de dolor (punzante, opresivo, eléctrico) · Cirugía y estudios · Farmacología · Salud mental · Ginecología · Pediatría · Protocolo de mala noticia'
  }, {
    icon: <GraduationCap className="w-6 h-6" data-id="element-252" />,
    title: 'Módulo Educación',
    color: 'text-blue-600',
    bgColor: 'bg-blue-100',
    items: 'Consignas de examen completas · Psicopedagogía · Materias de nivel secundario y terciario · Kit de emergencia docente · Vocabulario de disciplina y convivencia'
  }, {
    icon: <Building2 className="w-6 h-6" data-id="element-253" />,
    title: 'Módulo Banca y Comercio',
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-100',
    items: 'Vocabulario bancario profesional · Inversiones y préstamos · Seguros y coberturas · Atención al cliente técnica · RRHH y empleo · Vocabulario impositivo'
  }, {
    icon: <Scale className="w-6 h-6" data-id="element-254" />,
    title: 'Módulo Legal',
    color: 'text-slate-700',
    bgColor: 'bg-slate-200',
    items: 'Sistema judicial argentino · Delitos y denuncias · Derechos de las personas sordas · CUD · ANSES y PAMI avanzado · Mediación'
  }];
  return <section className="py-20 bg-slate-950" data-id="element-255">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-256">
        <div className="text-center mb-12" data-id="element-257">
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[18px]" data-id="element-258">
            🎯 ¿QUÉ AGREGA EL "LSA PROFESIONAL — EL SIGUIENTE NIVEL"?
          </h2>
          <p className="text-lg text-slate-300" data-id="element-259">
            La diferencia entre improvisar en tu trabajo y ser un profesional
            accesible.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="mb-16 overflow-x-auto pb-4" data-id="element-260">
          <div className="min-w-[800px]" data-id="element-261">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-262">
              <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-263">
                Situación real
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-264">
                <X className="w-4 h-4" data-id="element-265" /> Sin LSA Profesional
              </div>
              <div className="font-bold text-emerald-400 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-266">
                <Check className="w-4 h-4" data-id="element-267" /> Con LSA Profesional
              </div>
            </div>

            <div className="space-y-3" data-id="element-268">
              {comparisons.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-slate-900 rounded-xl p-4 items-center border border-slate-800" data-id="element-269">
                  <div className="font-medium text-white" data-id="element-270">{row.situation}</div>
                  <div className="text-slate-400 text-sm" data-id="element-271">{row.without}</div>
                  <div className="text-emerald-300 font-medium text-sm bg-emerald-950/40 p-2 rounded-lg border border-emerald-900/50" data-id="element-272">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-slate-500 mt-4 md:hidden" data-id="element-273">
            ← Scroll to see full table →
          </p>
        </div>

        {/* Modules Grid */}
        <div className="bg-slate-900 rounded-3xl p-8 md:p-12 text-white shadow-xl" data-id="element-274">
          <h3 className="font-bold mb-8 flex items-center gap-3 text-[16px]" data-id="element-275">
            <span className="bg-emerald-500 text-white p-1 rounded-full" data-id="element-276">
              <Check className="w-5 h-5" data-id="element-277" />
            </span>
            LSA PROFESIONAL INCLUYE:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-278">
            {modules.map((mod, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-800/50 rounded-2xl p-6 border border-slate-700" data-id="element-279">
                <div className="flex items-center gap-3 mb-4" data-id="element-280">
                  <div className={`p-2 rounded-lg ${mod.bgColor} ${mod.color}`} data-id="element-281">
                    {mod.icon}
                  </div>
                  <h4 className="font-bold text-lg" data-id="element-282">{mod.title}</h4>
                </div>
                <p className="text-slate-300 text-sm leading-relaxed" data-id="element-283">
                  {mod.items}
                </p>
              </motion.div>)}
          </div>

          <div className="bg-slate-800 rounded-xl p-6 border border-slate-700" data-id="element-284">
            <p className="text-sm text-slate-300 leading-relaxed" data-id="element-285">
              <strong className="text-amber-400" data-id="element-286">Más:</strong> Protocolo de
              recepción profesional · Checklist de accesibilidad institucional ·
              Mapa de redes para conseguir intérprete urgente · Glosario TOP 20
              por especialidad · Autoevaluación profesional · Certificado de
              especialización
            </p>
          </div>
        </div>
      </div>
    </section>;
}